
import "./App.css";
import {

  Route,
  Switch,
  BrowserRouter as Router,

} from "react-router-dom";
import Header from "./components/Header";
import Appbar from "./components/Appbar";
import Cryptos from "./pages/Cryptos";
import Vtrading from "./pages/Vtrading/Vtrading";
import VtradingScreen2 from "./pages/Vtrading/VtradingScreen2";
import VtradingScreen3 from "./pages/Vtrading/VtradingScreen3";
import VtradingScreen4 from "./pages/Vtrading/VtradingScreen4";
import VtradingScreen5 from "./pages/Vtrading/VtradingScreen5";
import Tradathon from "./pages/Tradathon/Tradathon.jsx";
import Footer from "./components/Footer";
import ParameterState from "./context/parameter/parameterState";
import CryptoState from "./context/crypto/cryptoState";
import TradathonState from "./context/tradathon/TradathonState";
import AuthState from "./context/auth/authState";
import VtradingState from "./context/vTrading/VTradingState";
import AlertState from "./context/alert/AlertState";
import Module from "./components/Module";
import Compare from "./pages/Compare";
import SingleCrypto from "./pages/SingleCrypto";
import Favourite from "./pages/Favourite";
import TradathonRoom from "./pages/Tradathon/TradathonRoom";
import PrivateRoute from "./utils/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import SocialAuth from "./components/auth/SocialAuth";
import TradathonAddCoins from "./pages/Tradathon/TradathonAddCoins";
import TradathonResult from "./pages/Tradathon/TradathonResult";
import Profile from "./pages/Profile/Profile";
import TradathonRoomShare from "./pages/Tradathon/TradathonRoomShare";
import News from "./pages/News";
import NewsState from "./context/News/NewsState";
import { Detector } from "react-detect-offline";

import Withdraw from "./pages/Withdraw";
import Associate from "./pages/content/Associate";
import FAQ from "./pages/content/FAQ";
import HowToPlay from "./pages/content/HowToPlay";
import Terms_Conditions from "./pages/content/Terms_Conditions";
import AssociateT_C from "./pages/content/AssociateT_C";
import PrivacyPolicy from "./pages/content/PrivacyPolicy";
import ResponsiblePlay from "./pages/content/ResponsiblePlay";
import NoI from "./assets/images/no_internet.png";
import { useWindowSize } from "react-use";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckOS from "./components/CheckOS";
function App() {
  const { width } = useWindowSize();
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={600000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        // pauseOnHover
      />
      <Router>
        <ScrollToTop />
        <AuthState>
          <ParameterState>
            <NewsState>
              <CryptoState>
                <VtradingState>
                  <TradathonState>
                    <AlertState>
                      <Header />
                      <Appbar />
                      <CheckOS />
                      <main
                        style={{
                          minHeight: "100vh",
                          maxWidth: "1920px",
                          margin: "0 auto",
                        }}
                      >
                        <Detector
                          onChange={(e) => console.log(e)}
                          render={({ online }) =>
                            online ? (
                              <Switch>
                                <Route path="/" exact component={Cryptos} />
                                <Route
                                  path="/cryptos/:id"
                                  exact
                                  component={SingleCrypto}
                                />
                                <PrivateRoute
                                  path="/vtrading"
                                  exact
                                  component={Vtrading}
                                />
                                <PrivateRoute
                                  path="/vtrading/screen"
                                  exact
                                  component={Cryptos}
                                />
                                <PrivateRoute
                                  path="/vtrading/screen2"
                                  exact
                                  component={VtradingScreen2}
                                />
                                <PrivateRoute
                                  path="/vtrading/screen3"
                                  exact
                                  component={VtradingScreen3}
                                />
                                <PrivateRoute
                                  path="/vtrading/screen4"
                                  exact
                                  component={VtradingScreen4}
                                />
                                <Route
                                  path="/vtrading/screen5"
                                  exact
                                  component={VtradingScreen5}
                                />
                                <PrivateRoute
                                  path="/tradathon"
                                  exact
                                  component={Tradathon}
                                />
                                <PrivateRoute
                                  path="/tradathon/room/share"
                                  exact
                                  component={TradathonRoomShare}
                                />
                                <PrivateRoute
                                  path="/tradathon/room"
                                  exact
                                  component={TradathonRoom}
                                />
                                <PrivateRoute
                                  path="/tradathon/room/join"
                                  exact
                                  component={TradathonRoom}
                                />
                                <PrivateRoute
                                  path="/tradathon/room/join/:id"
                                  exact
                                  component={TradathonRoom}
                                />
                                <PrivateRoute
                                  path="/favourite"
                                  exact
                                  component={Favourite}
                                />
                                <PrivateRoute
                                  path="/tradathon/screen"
                                  exact
                                  component={Cryptos}
                                />
                                <PrivateRoute
                                  path="/tradathon/room/result"
                                  exact
                                  component={TradathonResult}
                                />
                                <PrivateRoute
                                  path="/tradathon/roommember/portfolio"
                                  exact
                                  component={TradathonAddCoins}
                                />
                                {/* <Route
      path="/coinlearn"
      exact
      component={Coinlearn}
    /> */}
                                <Route
                                  path="/compare"
                                  exact
                                  component={Compare}
                                />
                                <Route
                                  path="/modules/:title"
                                  exact
                                  component={Module}
                                />
                                <Route
                                  path="/auth/:token"
                                  exact
                                  component={SocialAuth}
                                />
                                
                                <Route
                                  path="/tradathon/addcoins"
                                  exact
                                  component={TradathonAddCoins}
                                />
                                <PrivateRoute
                                  path="/profile"
                                  exact
                                  component={Profile}
                                />

                                <PrivateRoute
                                  path="/withdraw"
                                  exact
                                  component={Withdraw}
                                />
                                <PrivateRoute
                                  path="/wallet/withdraw/details"
                                  exact
                                  component={Withdraw}
                                />

                                <Route path="/news" component={News} exact />
                                <Route path="/faq" component={FAQ} exact />
                                <Route
                                  path="/associate"
                                  component={Associate}
                                  exact
                                />
                                <Route
                                  path="/how-to-play"
                                  component={HowToPlay}
                                  exact
                                />
                                <Route
                                  path="/terms-and-conditions"
                                  component={Terms_Conditions}
                                  exact
                                />
                                <Route
                                  path="/associate/terms-and-conditions"
                                  component={AssociateT_C}
                                  exact
                                />
                                <Route
                                  path="/privacy-policy"
                                  component={PrivacyPolicy}
                                  exact
                                />
                                <Route
                                  path="/responsible-play"
                                  component={ResponsiblePlay}
                                  exact
                                />
                              </Switch>
                            ) : (
                              <center>
                                {/* <Redirect to="/" /> */}
                                <img
                                  src={NoI}
                                  alt="unstable Network"
                                  style={{
                                    width: width < 900 ? "50%" : "20%",
                                    height: "auto",
                                  }}
                                />

                                <p>
                                  Network is Unstable, Please check your Network
                                  settings
                                </p>
                              </center>
                            )
                          }
                        />
                      </main>
                      <Footer />
                    </AlertState>
                  </TradathonState>
                </VtradingState>
              </CryptoState>
            </NewsState>
          </ParameterState>
        </AuthState>
      </Router>
    </div>
  );
}

export default App;
